import React from 'react';
import classnames from 'classnames';

import { Size, DEFAULT_SIZE, BASE_CLASS_NAME } from './WpAvatar';

// Components
import WpIcon from '../icon/WpIcon';

import './WpAvatarEmpty.scss';

type Props = {
  size?: Size;
};

const WpAvatarEmpty = ({ size = DEFAULT_SIZE }: Props) => {
  const baseClassName = 'WpAvatarEmpty';
  const classes = classnames(baseClassName, BASE_CLASS_NAME, `${BASE_CLASS_NAME}--${size}`);

  const iconSize = size === 'sm' ? 'md' : 'lg';

  // TODO: (@josh) need to flush out icon sizes for large size avatars
  if (size === 'xl' || size === 'xxl' || size === 'xxxl') return null;

  return (
    <div className={classes}>
      <WpIcon name="user" prefix="fas" size={iconSize} />
    </div>
  );
};

export default WpAvatarEmpty;
